import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AboutHero from './components/AboutHero';
import AboutStory from './components/AboutStory';
import VisionSection from './components/VisionSection';
import FAQSection from './components/FAQSection';
import ApproachSection from './components/ApproachSection';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <AboutHero />
        <AboutStory />
        <VisionSection />
        <FAQSection />
        <ApproachSection />
      </main>
      <Footer />
    </div>
  );
}